<div class="google-signin">
  <button (click)="signIn()" type="button" class="google-button" [disabled]="isLoading || !isInitialized">
    <ng-container *ngIf="!isLoading">
      <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google" />
      <span>{{ isInitialized ? 'Continue with Google' : 'Initializing...' }}</span>
    </ng-container>
    <ng-container *ngIf="isLoading">
      <div class="loading-content">
        <div class="spinner"></div>
        <span>Signing in...</span>
      </div>
    </ng-container>
  </button>
  <div *ngIf="errorMessage && !isLoading" class="error-state">
    <div class="error-message">{{errorMessage}}</div>
    <button (click)="errorMessage = ''" class="retry-button">
      Try again
    </button>
  </div>
</div>